import Comment from "../Comment";
import "./commentListStyle.css";

function CommentList({ comments, light }) {
  function getIntials(userName) {
    const initials = userName
      .split(" ")
      .map((i) => i[0])
      .join("");
    return initials.toUpperCase();
  }
  return (
    <section className={light ? "lightCommentList" : "darkCommentList"}>
      {comments.map((currentIteration) => {
        return (
          <Comment
            key={currentIteration.id}
            author={currentIteration.author}
            content={currentIteration.content}
            initials={getIntials(currentIteration.author)}
            light={light}
          />
        );
      })}
    </section>
  );
}

export default CommentList;
